module.exports = __webpack_public_path__ + "img/centered_face.5af19490.svg";